import { useRef } from "react";
import { Loader2, FileSpreadsheet, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { IMPORT_FIELDS, downloadTemplate } from "@/lib/clientImport";

const SKIP = "__skip__";
const ACCEPT = ".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const FilePick = ({ imp, testid = "client-import" }) => {
  const ref = useRef(null);
  const onFile = (e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) imp.pick(f); };
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 min-w-0">
      <input ref={ref} type="file" accept={ACCEPT} className="hidden" onChange={onFile} data-testid={`${testid}-file`} />
      <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={imp.busy} className="rounded-full" data-testid={`${testid}-choose`}>
        {imp.busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-2" />}
        {imp.sheet ? "Choose a different file" : "Choose spreadsheet"}
      </Button>
      <button type="button" onClick={downloadTemplate} className="text-xs font-medium text-primary hover:underline inline-flex items-center gap-1" data-testid={`${testid}-template`}>
        <Download className="w-3.5 h-3.5" /> Download a template
      </button>
      {imp.sheet && <span className="text-xs text-muted-foreground truncate max-w-full" data-testid={`${testid}-filename`}>{imp.sheet.file} · {imp.sheet.total} rows</span>}
    </div>
  );
};

const ColumnRow = ({ c, value, onChange, testid }) => (
  <div className="flex items-center gap-3 py-2 border-b border-border last:border-0" data-testid={`${testid}-col-${c.index}`}>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-medium truncate">{c.header}</p>
      <p className="text-xs text-muted-foreground truncate">{c.samples.join(" · ") || "Empty"}</p>
    </div>
    <Select value={value || SKIP} onValueChange={(v) => onChange(v === SKIP ? "" : v)}>
      <SelectTrigger className={`w-44 shrink-0 ${value ? "" : "text-muted-foreground"}`} data-testid={`${testid}-map-${c.index}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {IMPORT_FIELDS.map(([k, label]) => <SelectItem key={k} value={k}>{label}</SelectItem>)}
        <SelectItem value={SKIP}>Don&apos;t import</SelectItem>
      </SelectContent>
    </Select>
  </div>
);

export const ColumnMap = ({ imp, testid = "client-import" }) => (
  <div className="rounded-lg border border-border px-3 min-w-0" data-testid={`${testid}-columns`}>
    <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground pt-3">Match your columns</p>
    {imp.sheet.columns.map((c) => <ColumnRow key={c.index} c={c} value={imp.map[c.index]} onChange={(v) => imp.setField(c.index, v)} testid={testid} />)}
  </div>
);
